import { render, staticRenderFns } from "./ChartProdCons.vue?vue&type=template&id=577524be&scoped=true&"
import script from "./ChartProdCons.vue?vue&type=script&lang=ts&"
export * from "./ChartProdCons.vue?vue&type=script&lang=ts&"
import style0 from "./ChartProdCons.vue?vue&type=style&index=0&id=577524be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577524be",
  null
  
)

export default component.exports